import { FAQIcon, HomeIcon, IconPropsType, ResetPinIcon } from 'components/SVGS'

type NavigationOptions = {
  key: number
  name: string
  route: string
  icon: React.FC<IconPropsType>
  isNavLink: boolean,
  externalUrl?: string,
  routeToApp?: string
}

export const navigationOptions: NavigationOptions[] = [
  {
    key: 1,
    name: 'Inicio',
    icon: HomeIcon,
    route: '/my-vehicles',
    isNavLink: true
  },
  {
    key: 2,
    name: 'Restablecer PIN',
    icon: ResetPinIcon,
    route: '/reset-pin',
    isNavLink: true
  },
  {
    key: 3,
    name: 'Crear PIN',
    icon: ResetPinIcon,
    route: '/create-pin',
    isNavLink: true
  },
  {
    key: 4,
    name: 'Preguntas frecuentes',
    icon: FAQIcon,
    route: 'https://www.wicar.cl/preguntas-frecuentes/',
    isNavLink: false,
    externalUrl: 'https://www.wicar.cl/preguntas-frecuentes/',
    routeToApp: 'faq'
  },
  {
    key: 5,
    name: 'Términos y condiciones',
    icon: FAQIcon,
    route: '/',
    isNavLink: false,
    externalUrl: 'https://www.wicar.cl/t%C3%A9rminos-y-condiciones',
    routeToApp: 'terms-and-conditions'
  },
]
